import client from 'api/graphQL/config'
import {gql, TypedDocumentNode} from '@apollo/client'
import {Query} from 'graphql-api'
import {DiagnosticSortInput, DiagnosticType} from 'api/graphQL/generated/graphql'

const fragments = {
  databaseDetailsFields: gql`
    fragment databaseDetailsFields on DatabaseMetadata {
      databaseId,
      databaseName,
      databaseVersion,
      databaseType {
        isStudy,
        isStudyGroup
      },
      raveUrl,
      sqlServerId,
      sqlServerName,
      studyGroupUuids,
      studyUuids,
      lastSyncTimeStamp,
      active,
      enabled,
      isClassic,
      appVersion
      hostname
    }
  `,
}

const GET_ACTIVE_DATABASE_URLS: TypedDocumentNode<Query> = gql`
  query GetDatabaseStudyGroupUuids {
    databases (
      where: {active: {eq: true}}
    ) {
      raveUrl
      databaseId
      hostname
    }
  }
`
const GET_DIAGNOSTIC_OPTIONS = gql`
  query DiagnosticOptions {
    diagnosticOptions {
      name
      diagnosticScript
    }
  }
`

export const GET_DIAGNOSTICS = gql`
  query GetDiagnostics(
    $databaseId: UUID!
    $type: DiagnosticType!
    $take: Int
    $skip: Int
    $searchText: String
    $sorting: DiagnosticSortInput
  ) {
    diagnostics(
      databaseId: $databaseId
      type: $type
      take: $take
      skip: $skip
      searchText: $searchText
      sorting: $sorting
    ) {
      columns
      totalCount
      items {
        id
        data
        ... on BulkOperationDiagnostic {
          queueId
          extracted
          subjectId
          objectType
          userId
          studyId
          objectIds
          operationType
          reviewGroupId
          roleId
          roleName
          startTime
          studyName
          environmentName
          subjectName
          subjectUuid
          userName
        }
        ... on StatusRollupProgress {
          completed
          completedPercent
          elapsedSeconds
          failed
          failedPercent
          finalError
          initiationDate
          notStarted
          progress
          requestId
          running
          taskCount
          taskSource
        }
        ... on StatusRollupDiagnostic {
          environmentName
          hostname
          objectId
          objectType
          operation
          parentTaskId
          refreshClinicalView
          requestId
          insertedOn
          startedOn
          lastProcessedOn
          completedOn
          retries
          roleId
          roleName
          siteName
          status
          studyId
          studyName
          subjectName
          subjectUuid
          taskId
          taskSource
        }
      }
    }
  }
`

export const GetDiagnosticOptions = () =>
  client.query({
    query: GET_DIAGNOSTIC_OPTIONS,
  })

export const getActiveDatabaseUrls = () => client.query({
  query: GET_ACTIVE_DATABASE_URLS,
})

export const getDiagnosticResults = (
  databaseId: string,
  type: DiagnosticType,
  skip: number,
  take: number,
  searchText?: string,
  sorting?: DiagnosticSortInput
) =>
  client.query({
    query: GET_DIAGNOSTICS,
    variables: {
      databaseId,
      type,
      skip: skip,
      take: take,
      searchText,
      sorting,
    },
  })
